<template>

  <div class="comments" >
    <!-- 时间 选择 -->
      <van-calendar v-model="show" allow-same-day="true" :formatter="formatter" :title="$t('other.Date_range')" :confirm-text="$t('btn.submit')" :min-date="minDate" :max-date="maxDate" type="range" @confirm="onConfirm" />
      <van-row class="my_returns_detailed">
        <!-- 时间 查询 -->
        <van-col  span="22" offset="1" class="my_returns_detailed_top">
          <van-col span="24" class="my_returns_detailed_time">
            <van-cell :title="$t('other.Date_range')" :value="date" @click="show = true" />
          </van-col>
        </van-col>
        <van-col span="22" offset="1">
          <van-tabs v-model="active" @click="onClicktype">
            <van-tab :title="$t('other.income')">
              <van-col span="24" v-if="is_list">
                <van-list
                  v-model="loading"
                  :finished="finished"
                  :immediate-check="false"
                  :finished-text="$t('onLoad.finished_text')"
                  @load="onLoad"
                  :offset="10"
                >
                  <van-cell v-for="t in list" :key="t.id">
                    <van-col span="24" class="my_returns_type">
                      <van-col span="18">
                        <van-col span="24" class="my_returns_type_name">{{ t.content }}</van-col>
                        <van-col span="24" class="my_returns_type_time">{{ t.create_time }}</van-col>
                      </van-col>
                      <van-col span="6" class="my_returns_type_money"> +{{ t.money }}</van-col>
                    </van-col>
                  </van-cell>
                </van-list>

              </van-col>
              <van-col span="24" v-else>
                <van-col span="24" class="no-data">
                  <img src="../assets/img/zwsl.png"/>
                </van-col>
                <van-col span="24" class="no-data-name" >{{ $t('onLoad.No_record') }}</van-col>
              </van-col>
            </van-tab>
            <van-tab :title="$t('other.Withdrawal_record')">
              <van-col span="24" v-if="is_list">
                <van-list
                  v-model="loading"
                  :finished="finished"
                  :immediate-check="false"
                  :finished-text="$t('onLoad.finished_text')"
                  @load="onLoad"
                  :offset="10"
                >
                  <!--  直播间收益扣费记录  -->
                  <van-cell v-for="t in list" :key="t.id">
                    <van-col span="24" class="my_returns_type">
                      <van-col span="16">
                        <van-col span="24" class="my_returns_type_name">{{ t.title }}</van-col>
                        <van-col span="24" class="my_returns_type_time">{{ t.addtime }}</van-col>
                      </van-col>
                      <van-col span="8" class="my_returns_type_money">
                        <van-col span="24" class="my_returns_type_money_val"> {{ t.deduction_income }} </van-col>
                        <van-col span="24" class="my_returns_type_money_status"> {{ t.duration }} </van-col>
                      </van-col>
                    </van-col>
                  </van-cell>

                        <!-- 提现记录 -->
<!--                 <van-cell v-for="t in list" :key="t.id">-->
<!--                    <van-col span="24" class="my_returns_type">-->
<!--                      <van-col span="18">-->
<!--                        <van-col span="24" class="my_returns_type_name">{{ $t('other.Withdrawal')}}</van-col>-->
<!--                        <van-col span="24" class="my_returns_type_time">{{ t.create_time }}</van-col>-->
<!--                      </van-col>-->
<!--                      <van-col span="6" class="my_returns_type_money">-->
<!--                        <van-col span="24" class="my_returns_type_money_val"> +{{ t.money }} </van-col>-->
<!--                        <van-col span="24" class="my_returns_type_money_status"> {{ t.status_name }} </van-col>-->
<!--                      </van-col>-->
<!--                    </van-col>-->
<!--                  </van-cell>-->
                </van-list>
              </van-col>
              <van-col span="24" v-else>
                <van-col span="24" class="no-data">
                  <img src="../assets/img/zwsl.png"/>
                </van-col>
                <van-col span="24" class="no-data-name" >{{ $t('onLoad.No_record') }}</van-col>
              </van-col>
            </van-tab>
          </van-tabs>
        </van-col>
      </van-row>
  </div>
</template>
<script>
  //请求接口组件
  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast";
  export default {
    data() {
      return {
        date: '',
        show: false,
        finished: false,
        loading: false,
        active: 0,
        dateType: 1,
        minDate: new Date(2019, 0, 1),
        maxDate: new Date(2025, 10, 1),
        currentDate: new Date(),
        list: [],
        is_list: false,
        value1: '',
        value2: '',
        page: 1
      }
    },
    created: function() {
      this.page = 1
      this.list = []
      this.select_list()
      document.title = this.$t('title.Income_details')
    },
    methods: {
      formatter(day) {
        if (day.type === 'start') {
          day.bottomInfo = '';
        } else if (day.type === 'end') {
          day.bottomInfo = '';
        }

        return day;
      },
      formatDate(date) {
        return `${date.getMonth() + 1}`+ this.$t('other.month') +`${date.getDate()}` + this.$t('other.day')
      },
      onConfirm(date) {
        const [start, end] = date
        this.show = false
        this.value1 = `${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()}`
        this.value2 = `${end.getFullYear()}-${end.getMonth() + 1}-${end.getDate()}`
        this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`
        this.inquire_btn()
      },
      onClicktype (name, title) {
        this.list = []
        this.page = 1
        this.active = name
        this.select_list()
      },
      onLoad() {
        this.select_list()
      },
      inquire_btn() {
        this.page = 1
        this.list= []
        this.select_list()
      },
      select_list() {
          const uid = this.$route.query.uid
          const token = this.$route.query.token

         // const url = this.active !== 1 ?  "mapi/public/index.php/api/userinfo_api/vue_earnings_log" : "mapi/public/index.php/api/userinfo_api/vue_earnings_page" //提现
          const url = this.active !== 1 ?  "mapi/public/index.php/api/userinfo_api/vue_earnings_log" : "mapi/public/index.php/api/userinfo_api/vue_room_deduction_income_log"


          axios.get(this.baseUrlApi + url, {
            params: {
              uid: uid,
              token: token,
              p: this.page,
              start_time: this.value1,
              end_time: this.value2
            }
          }).then(res => {
            if (res.data.code == 1) {
              if (res.data.list.length > 0) {
                for (let i = 0; i < res.data.list.length; i++) {
                  this.list.push(res.data.list[i])
                }
                this.is_list = true
                this.loading = false
                this.page = this.page + 1
              } else {
                if(this.page == 1) {
                  this.is_list = false
                }
                this.finished = true
                this.loading = true
              }
            } else {
              if(this.page == 1) {
                this.is_list = false
              }
              this.loading = true
              if(this.page !== 1) {
                Toast(this.$t('onLoad.No_data_available'))
              }
            }
          })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/returns_detailed.vue